import { Box, Card, FormControl, IconButton, NativeSelect, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyGetSpecificCompanyPropertyByIdQuery } from "../../services/users";
import Loader from "../../helpers/constants/Loader";
import Pagination from "../../components/Pagination";
import WarnModal from "../../components/WarnModal";
import { errorToast, successToast } from "../../helpers/toast";
import { useDeleteByIdPropertyMutation } from "../../services/property";


const AgentProperty = () => {
  const navigate = useNavigate();
  const { _id } = useParams();
  const [open, setOpen] = useState(false);
  const [deletePropertyById] = useDeleteByIdPropertyMutation();
  const [propertyType,setPropertyType]=useState<number>(0)
  const [propertyStatus,setPropertyStatus]=useState<number>(0)
  const [totalCount, setTotalCount] = useState<number>(0);
  const [allDetailsById, setAllDetailsById] = useState<any>([]);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [AllDetails, { isLoading }] = useLazyGetSpecificCompanyPropertyByIdQuery();
  const [limit, setLimit] = useState<number>(10);
  let totalPages = Math.ceil(totalCount / limit);
  const [page, setPage] = useState(1);
  const onPageChange1 = (newPage: number) => {
    setPage(newPage);
    setAllDetailsById([]);
  };
  const fetchAllDataById = async () => {
    try {
      const response = await AllDetails({ userId: _id,listingType:propertyType===0 ? "":propertyType,propertyStatus:propertyStatus===0? "":propertyStatus }).unwrap();
      if (response.statusCode === 200) {
        setAllDetailsById(response?.data?.propertyDetails || []);
        setTotalCount(response?.data?.count || 0);
      }
    } catch (error: any) {

      errorToast(error?.message || "");
    }
  };
  const handleDeleteProperty = async (userId: any) => {
    try {
      const response = await deletePropertyById({ userId }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Property deleted successfully");
        fetchAllDataById();

      }
    } catch (error: any) {

      errorToast(error?.message || "");
    }
  };



  useEffect(() => {
    if (_id) {
      fetchAllDataById()
    }

  }, [propertyStatus,propertyType]);

  return (
    <>
      <Card className="cards">
        {/* <Box className="cards_header">
          <Box className="cards_header_right">
          </Box>
        </Box> */}
        <div>
          <FormControl>
            <div style={{marginRight:"10px"}}>
              <NativeSelect
                value={propertyStatus}
                onChange={(e)=>setPropertyStatus(Number(e.target.value))}
                inputProps={{
                  name: "report",
                  id: "uncontrolled-native",
                }}
              >
                <option value={0} disabled>Select Property Status</option>
                <option value={1}>Sold Properties</option>
                <option value={2}>Rental Properties</option>
                <option value={3}>Live Properties</option>

              </NativeSelect>
            </div>
          </FormControl>
          <FormControl>
            <div>
              <NativeSelect
                value={propertyType}
                onChange={(e)=>setPropertyType(Number(e.target.value))}
                inputProps={{
                  name: "report",
                  id: "uncontrolled-native",
                }}
              >
                <option value={0} disabled>Select Property Type</option>
                <option value={1}>Standard</option>
                <option value={2}>Featured</option>
                <option value={3}>Premium</option>
              </NativeSelect>
            </div>
          </FormControl>
        </div>
        <Loader isLoad={isLoading} />
        <TableContainer className="table_container">
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">S.No</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Property Status</TableCell>
                <TableCell>Property Type</TableCell>
                <TableCell>Agent</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allDetailsById.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No property found
                  </TableCell>
                </TableRow>
              ) : (
                allDetailsById.map((row: any, index: any) => (
                  <TableRow key={row?._id}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell>
                      <figure className="user_img">
                        <img style={{ borderRadius: 0 }} src={row?.images?.[0] || "/static/images/house.jpg"} alt="" />
                      </figure>
                    </TableCell>
                    <TableCell>{row?.name || "-"}</TableCell>
                    <TableCell>{row?.address || "-"}</TableCell>
                    <TableCell>{row?.propertyStatus === 1 ? "Rented" : row?.propertyStatus === 2 ? "Sold" : "Live"}</TableCell>
                    <TableCell>{row?.listingType === 1 ? "Standard" : row?.listingType === 2 ? "Featured" : "Premium"}</TableCell>
                    <TableCell>{row?.ownerName || "-"}</TableCell>
                    <TableCell>
                      <Box className="table_actions">
                        <IconButton onClick={() => navigate(`/manage-agents/property-listing/details/${row?._id}`)}>
                          <VisibilityIcon />
                        </IconButton>
                        <IconButton onClick={() => {
                          setOpen(true);
                          setSelectedId(row?._id);
                        }}>
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
      {allDetailsById?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={allDetailsById}
          limit={limit}
          setLimit={setLimit}
          page={page}
          onPageChange={onPageChange1}
          totalPages={totalPages}
        />
      ) : (
        ""
      )}
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDeleteProperty(selectedId)}
        name="Property"
      />
    </>
  );
};

export default AgentProperty;
